// extracted by mini-css-extract-plugin
export default {"container":"hertitude_container__MGnhu","sunglasses_img":"hertitude_sunglasses_img__yWPzG"};